var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { render } from "react-dom";
import * as React from "react";
export function initReactApp(element, PageComponent, props) {
    if (props === void 0) { props = {}; }
    var root = element instanceof HTMLElement
        ? element
        : document.querySelector(element);
    if (!root) {
        return;
    }
    var components = (React.createElement(PageComponent, __assign({}, props)));
    render(components, root);
}
export function initReactRootApp(PageComponent) {
    initReactApp('#root', PageComponent);
}
export function initReactRootAppOnDOMContentLoaded(PageComponent) {
    document.addEventListener('DOMContentLoaded', function () {
        initReactRootApp(PageComponent);
    });
}
